import axiosInstance from "../utils/axios/axios";
import privateAxiosInstance from "../utils/axios/private";
import { hybridEncrypt, hybridDecrypt } from "../utils/crypto";

export const questionApi = {
    /**
     * Retrieve matching QA for candidate or recruiter.
     * Endpoint: /question/start/
     * Method: POST
     * @param {object} payload - Input data for matching QA retrieval.
     */
    async retrieveMatchingQA(payload) {
        try {
            const response = await privateAxiosInstance.post("/question/start/");
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Generate questions asynchronously (e.g., background question generation).
     * Endpoint: /question/async/
     * Method: POST
     * @param {object} payload - Input data for async question generation.
     */
    async generateQuestionsAsync(payload) {
        try {
            const response = await privateAxiosInstance.post("/question/async/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },

    /**
     * Generate questions directly based on JD.
     * Endpoint: /question/generate/
     * Method: POST
     * @param {object} payload - JD details or parameters for question generation.
     */
    async generateQuestionsFromJD(payload) {
        try {
            const response = await privateAxiosInstance.post("/question/generate/", payload);
            if (response.data.encrypted) {
                return await hybridDecrypt(response.data);
            }
            return response.data
        } catch (error) {
            if (error.code === "ERR_NETWORK") {
                return {
                    status: 0,
                    data: "Network_error",
                    message: "Network error. Please check your internet connection or try again later.",
                    type: "network_error",
                }
            }
            return error.response.data
        }
    },
};
